@if (text()) {
  <mat-form-field>
    <textarea
      cdkTextareaAutosize
      cdkAutosizeMinRows="2"
      matInput [(ngModel)]="text()!.text"></textarea>
  </mat-form-field>
}
@switch (type()) {
  @case ('newFull') {
    <p style="display: none" spbText>
      {{ customer() }} är ny helkund (vardagspaket, sparande & lön in på kontot) i banken.
      Flytt av kunds engagemang ( {{ amount() }} kr) från annan bank är planerat till
      {{ date() }} och ligger till grund för prissättningen i denna lönsamhetskalkyl. Efter en affärsmässig genomgång av
      {{ customer() }} kommande helkundsengagemang följer nedan ett förslag om prissättning. Om fallet är att
      {{ customer() }} inte blir helkund inom
      {{ months() }} månader från beviljad kalkyl, kommer prissättningen att ses över på nytt utifrån gällande
      förutsättningar. Detta uppföljningsuppdrag åligger mig som rådgivare.
    </p>
  }
  @case ('newPart') {
    <p style="display: none" spbText>
      {{ customer() }} är ny delkund (delar av kundens totala bankengagemang läggs i banken, så som XXX, XXX & XXX
      ). Flytt av kunds engagemang ({{ amount() }} kr) från annan bank är planerat till {{ date() }} och ligger till
      grund för prissättningen i denna lönsamhetskalkyl. Efter en affärsmässig genomgång av {{ customer() }} kommande
      delengagemang, bedömer jag att kunden skall erbjudas X,XX punkter rabatt. Om fallet är att {{ customer() }} inte
      blir delkund med ovan beskrivna produkter och tjänster
      inom {{ months() }} månader från beviljad kalkyl, kommer prissättningen att ses över på nytt utifrån gällande
      förutsättningar. Detta uppföljningsuppdrag åligger mig som rådgivare.
    </p>
  }
  @case ('currentFull') {
    <p style="display: none" spbText>
      {{ customer() }} är helkund (vardagspaket, sparande & lön in på kontot) i banken sedan tidigare. Efter en
      affärsmässig
      genomgång av {{ customer() }} helkundsengagemang följer nedan förslag om prissättning.
    </p>
  }
  @case ('currentPart') {
    <p style="display: none" spbText>
      {{ customer() }} är befintlig delkund i banken. Efter en affärsmässig genomgång av {{ customer() }} delengagemang
      bestående
      av {{ x() }}, {{ x() }} & {{ x() }} följer nedan förslag om prissättning.
    </p>
  }
  <!-- -->
  @case ('newLoan') {
    <p style="display: none" spbText>
      Bakgrunden till denna lönsamhetskalkyl är att {{ customer() }} har ansökt om nytt bolån ({{ amount() }}) kr och
      som kundens
      rådgivare bedömer jag att {{ customer() }} skall erbjudas {{ discount() }} punkter. </p>
  }
  @case ('renewal') {
    <p style="display: none" spbText>
      Bakgrunden till denna lönsamhetskalkyl är att {{ customer() }} har omsättning på sitt/sina bolån per
      datum {{ date() }} och som kundens rådgivare bedömer jag att {{ customer() }} skall erbjudas {{ discount() }}
      punkter rabatt.
    </p>
  }
  @case ('offer') {
    <p style="display: none" spbText>
      Bakgrunden till denna lönsamhetskalkyl är att bankens befintliga kund har fått ett priserbjudande från annan bank,
      där jag som kundens rådgivare bedömer att {{ customer() }} skall erbjudas {{ discount() }} punkter rabatt mot
      listräntan
      per {{ date() }} i syfte att motverka att kunden lämnar banken.
    </p>
  }
  @case ('amortizationBase') {
    <p style="display: none" spbText>
      Bakgrunden till denna lönsamhetskalkyl är att bankens befintliga kund har begärt ut ett amorteringsunderlag på
      krediterna i vår bank. Som kundens rådgivare bedömer jag att {{ date() }} skall erbjudas {{ discount() }} punkter
      rabatt i syfte att motverka att kunden lämnar banken.
    </p>
  }
  <!-- -->
  @case ('custBoundLoan') {
    <p style="display: none" spbText>
      {{ customer() }} har sedan tidigare {{ x() }} bundna lån med en total intjäning om
      {{ x() }} kr. Detta/dessa lån har en internränta som beräknats och visats annorlunda historiskt, vilket medför att
      lånen inte speglas så som om lånet/lånen blivit bundna idag. Se sammanställning för tydlig överblick.
    </p>
  }
  @case ('custSavings') {
    <p style="display: none" spbText>
      {{ customer() }} har ett sparkapital i banken som genererar en över tid positiv intjäning till banken. Kunden har
      en
      löpande dialog med banken kopplat till utveckling av sparkapitalet och nya affärsmöjligheter som bidrar till en
      affärsmässig utveckling med kunden i fokus.
    </p>
  }
  @case ('custPrivateBanking') {
    <p style="display: none" spbText>
      {{ customer() }} har en Private Banking-rådgivare som flera gånger om året arbetar strukturerat och målinriktat
      för
      att utveckla kundens portfölj och bidra till en positiv intjäning till banken. Inför upprättande av
      lönsamhetskalkyl har jag som rådgivare haft dialog med kundens private banking-rådgivare för att kunna lämna en
      affärsmässig prissättning.
    </p>
  }
  @case ('custCorp') {
    <p style="display: none" spbText>
      {{ customer() }} har ett företag som är kund i banken, företag {{ x() }}. Företagsengagemanget bidrar till en
      positiv
      intjäning till banken löpande.
    </p>
  }
  @case ('custPartner') {
    <p style="display: none" spbText>
      {{ customer() }} har blivit kund i vår bank genom vårt samarbete med PARTNER.
    </p>
  }
  @case ('custImportant') {
    <p style="display: none" spbText>
      {{ customer() }} har en koppling till banken genom {{ x() }}
      <i>eg. huvudman, tidigare anställd, ambassadör etc.</i>
    </p>
  }
  @case ('custPotential') {
    <p style="display: none" spbText>
      Jag som rådgivare har identifierat och fört dialog med {{ customer() }} om att hjälpa till att utveckla och
      framtidsplanerna med följande produkter {{ x() }}, {{ x() }} och {{ x() }}. Detta har vi bokat möte för att
      verkställa
      (XXXX-XX-XX) och föreslagen prissättning är beroende av att dessa affärer genomförs senast inom {{ x() }} månader
      ifrån beviljad lönsamhetskalkyl. Om affärerna nämnda ovan ej blir av, kommer prissättningen att ses över på nytt
      utifrån gällande förutsättningar. Detta uppföljningsuppdrag åligger mig som rådgivare.
    </p>
  }
  @case ('decisionOwn') {
    <p style="display: none" spbText>
      Kunden påvisar {{ x() }} återbetalningsförmåga och en {{ x() }} intern och extern skötsamhet.
      Med affärsmässighet för såväl kund som bank och med ovan information i beaktande väljer jag att bevilja kundens
      lönsamhetskalkyl.

    </p>
  }
  @case ('decisionOther') {
    <p style="display: none" spbText>
      Kunden påvisar {{ x() }} återbetalningsförmåga och en {{ x() }} intern och extern skötsamhet.
      Med affärsmässighet för såväl kund som bank och med ovan information i beaktande väljer jag att tillstyrka
      kundens lönsamhetskalkyl för beslut.
    </p>
  }
}
